import { FC, useState } from 'react';
import { CollapsibleProps } from 'react-collapsible';
import styled from 'styled-components';

import { CoreFooterFeature } from '#/service/config/features.types';
import { remify } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

import { Accordion } from '../Accordion/Accordion';
import {
  AccordionContainer,
  AccordionTitle,
} from '../Accordion/Accordion.styled';
import { FooterLink } from './FooterLink';
import { Logo } from './Logo';

const LogoContainer = styled.div`
  width: 100%;
  text-align: center;
  margin: ${remify(50)} 0;
`;

const Title = styled(AccordionTitle)`
  color: var(--pageHeadingForeground);
`;

export const FooterAccordion: FC<Pick<CoreFooterFeature, 'sections'>> = ({
  sections,
}) => {
  const [expandedPanel, setExpandedPanel] = useState<
    string | number | undefined
  >('');

  const handleChange: CollapsibleProps['handleTriggerClick'] = (panel) => {
    setExpandedPanel(expandedPanel === panel ? '' : panel);
  };

  return (
    <AccordionContainer>
      {sections.map(({ display: { title }, items }) => (
        <Accordion
          itemKey={title}
          key={title}
          onTrigger={handleChange}
          open={title === expandedPanel}
          tabIndex={0}
          triggerElement={<Title>{tb(title)}</Title>}
        >
          {items.map(({ key, ...rest }) => (
            <FooterLink key={key} {...rest} />
          ))}
        </Accordion>
      ))}
      <LogoContainer>
        <Logo />
      </LogoContainer>
    </AccordionContainer>
  );
};
